<div class="not-found">
  <h1 i18n>404</h1>
  <h2 i18n>La pàgina que estàs buscant no existeix</h2>
</div>
